import { render, staticRenderFns } from "./authority-tips.vue?vue&type=template&id=02fd41f0&scoped=true"
import script from "./authority-tips.vue?vue&type=script&lang=js"
export * from "./authority-tips.vue?vue&type=script&lang=js"
import style0 from "./authority-tips.vue?vue&type=style&index=0&id=02fd41f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fd41f0",
  null
  
)

export default component.exports